// Generated by scripts/generate-tokens.mjs from tokens/*.json — do not edit by hand.
// Re-run: node scripts/generate-tokens.mjs

export const lightColors = {
  "actionPrimary": "#97271c",
  "actionPrimaryHover": "#741a11",
  "actionPrimaryActive": "#561009",
  "actionSecondary": "#f2eee9",
  "actionSecondaryHover": "#e4ddd5",
  "actionSecondaryActive": "#ccc2b7",
  "actionDestructive": "#b91c1c",
  "actionDestructiveHover": "#991b1b",
  "feedbackSuccessBg": "#f1fcf5",
  "feedbackSuccessText": "#183526",
  "feedbackSuccessBorder": "#a8cfb9",
  "feedbackSuccessIcon": "#2d6147",
  "feedbackWarningBg": "#fffbeb",
  "feedbackWarningText": "#92400e",
  "feedbackWarningBorder": "#fcd34d",
  "feedbackWarningIcon": "#d97706",
  "feedbackErrorBg": "#fef2f2",
  "feedbackErrorText": "#991b1b",
  "feedbackErrorBorder": "#fca5a5",
  "feedbackErrorIcon": "#dc2626",
  "feedbackInfoBg": "#eff6ff",
  "feedbackInfoText": "#1e40af",
  "feedbackInfoBorder": "#93c5fd",
  "feedbackInfoIcon": "#2563eb",
  "textPrimary": "#0d0b08",
  "textSecondary": "#473e33",
  "textTertiary": "#5f5345",
  "textDisabled": "#ccc2b7",
  "textOnAction": "#faf8f5",
  "textOnDark": "#faf8f5",
  "textLink": "#97271c",
  "textLinkHover": "#561009",
  "surfacePage": "#ece6de",
  "surfaceCard": "#fffdfa",
  "surfaceRaised": "#fffdfa",
  "surfaceSunken": "#e4ddd5",
  "surfaceOverlay": "rgba(13, 11, 8, 0.5)",
  "surfaceDisabled": "#f2eee9",
  "borderDefault": "#e4ddd5",
  "borderStrong": "#796c5d",
  "borderFocus": "#97271c",
  "borderError": "#dc2626",
  "borderDisabled": "#e4ddd5",
  "interactiveHoverOverlay": "rgba(13, 11, 8, 0.04)",
  "interactiveActiveOverlay": "rgba(13, 11, 8, 0.08)",
  "interactiveSelectedBg": "#ffede5",
  "interactiveSelectedBorder": "#ffc8bb",
  "interactiveFocusRing": "#97271c",
  "badgeNeutralBg": "#f2eee9",
  "badgeNeutralText": "#473e33",
  "badgePrimaryBg": "#ffded4",
  "badgePrimaryText": "#741a11",
  "badgeSuccessBg": "#e1f4e9",
  "badgeSuccessText": "#214935",
  "badgeWarningBg": "#fef3c7",
  "badgeWarningText": "#b45309",
  "badgeErrorBg": "#fee2e2",
  "badgeErrorText": "#b91c1c",
  "buttonPrimaryBg": "#97271c",
  "buttonPrimaryBgHover": "#741a11",
  "buttonPrimaryBgActive": "#561009",
  "buttonPrimaryText": "#faf8f5",
  "buttonSecondaryBg": "#f2eee9",
  "buttonSecondaryBgHover": "#e4ddd5",
  "buttonSecondaryText": "#0d0b08",
  "buttonGhostBgHover": "rgba(13, 11, 8, 0.04)",
  "buttonGhostText": "#0d0b08",
  "buttonDestructiveBg": "#b91c1c",
  "buttonDestructiveBgHover": "#991b1b",
  "buttonDestructiveText": "#faf8f5",
  "buttonDisabledBg": "#f2eee9",
  "buttonDisabledText": "#ccc2b7",
  "inputBg": "#fffdfa",
  "inputBgDisabled": "#f2eee9",
  "inputBorder": "#e4ddd5",
  "inputBorderHover": "#796c5d",
  "inputBorderFocus": "#97271c",
  "inputBorderError": "#dc2626",
  "inputText": "#0d0b08",
  "inputPlaceholder": "#5f5345",
  "cardBg": "#fffdfa",
  "cardBorder": "#e4ddd5",
  "avatarBg": "#e4ddd5",
  "avatarText": "#473e33",
  "avatarBorder": "#ffffff"
} as const;

export const darkColors = {
  "textPrimary": "#faf8f5",
  "textSecondary": "#ccc2b7",
  "textTertiary": "#aea395",
  "textDisabled": "#5f5345",
  "textOnAction": "#faf8f5",
  "textLink": "#ee8170",
  "textLinkHover": "#ffa898",
  "surfacePage": "#1e1a15",
  "surfaceCard": "#332d25",
  "surfaceRaised": "#473e33",
  "surfaceSunken": "#000000",
  "surfaceDisabled": "#332d25",
  "borderDefault": "#473e33",
  "borderStrong": "#796c5d",
  "borderFocus": "#b74234",
  "actionPrimary": "#b74234",
  "actionPrimaryHover": "#97271c",
  "actionSecondary": "#332d25",
  "actionSecondaryHover": "#473e33",
  "actionDestructive": "#ef4444",
  "actionDestructiveHover": "#dc2626",
  "interactiveHoverOverlay": "rgba(250, 248, 245, 0.04)",
  "interactiveActiveOverlay": "rgba(250, 248, 245, 0.08)",
  "interactiveSelectedBg": "#370503",
  "interactiveSelectedBorder": "#b74234",
  "feedbackSuccessBg": "#0d1f15",
  "feedbackSuccessText": "#e1f4e9",
  "feedbackSuccessBorder": "#81b296",
  "feedbackSuccessIcon": "#a8cfb9",
  "feedbackWarningBg": "#78350f",
  "feedbackWarningText": "#fef3c7",
  "feedbackWarningBorder": "#fbbf24",
  "feedbackWarningIcon": "#fcd34d",
  "feedbackErrorBg": "#7f1d1d",
  "feedbackErrorText": "#fee2e2",
  "feedbackErrorBorder": "#f87171",
  "feedbackErrorIcon": "#fca5a5",
  "feedbackInfoBg": "#1e3a8a",
  "feedbackInfoText": "#dbeafe",
  "feedbackInfoBorder": "#60a5fa",
  "feedbackInfoIcon": "#93c5fd",
  "badgeNeutralBg": "#473e33",
  "badgeNeutralText": "#f2eee9",
  "badgePrimaryBg": "#370503",
  "badgePrimaryText": "#ffded4",
  "badgeSuccessBg": "#0d1f15",
  "badgeSuccessText": "#e1f4e9",
  "badgeWarningBg": "#78350f",
  "badgeWarningText": "#fef3c7",
  "badgeErrorBg": "#7f1d1d",
  "badgeErrorText": "#fee2e2",
  "buttonPrimaryBg": "#b74234",
  "buttonPrimaryBgHover": "#97271c",
  "buttonPrimaryBgActive": "#561009",
  "buttonPrimaryText": "#faf8f5",
  "buttonSecondaryBg": "#332d25",
  "buttonSecondaryBgHover": "#473e33",
  "buttonSecondaryText": "#faf8f5",
  "buttonGhostBgHover": "rgba(250, 248, 245, 0.04)",
  "buttonGhostText": "#faf8f5",
  "buttonDestructiveBg": "#ef4444",
  "buttonDestructiveBgHover": "#dc2626",
  "buttonDestructiveText": "#faf8f5",
  "buttonDisabledBg": "#332d25",
  "buttonDisabledText": "#5f5345",
  "inputBg": "#332d25",
  "inputBgDisabled": "#332d25",
  "inputBorder": "#473e33",
  "inputBorderHover": "#796c5d",
  "inputBorderFocus": "#b74234",
  "inputBorderError": "#dc2626",
  "inputText": "#faf8f5",
  "inputPlaceholder": "#aea395",
  "cardBg": "#332d25",
  "cardBorder": "#473e33",
  "avatarBg": "#e4ddd5",
  "avatarText": "#473e33",
  "avatarBorder": "#ffffff"
} as const;

export const space = {
  "1": 4,
  "2": 8,
  "3": 12,
  "4": 16,
  "5": 20,
  "6": 24,
  "8": 32,
  "16": 64,
  "0_5": 2
} as const;

export const radius = {
  "sm": 8,
  "md": 12,
  "lg": 16,
  "xl": 24,
  "full": 9999
} as const;

export const fontFamily = {
  "sans": "Libre Franklin, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif",
  "serif": "Fraunces, Georgia, Cambria, Times New Roman, serif",
  "mono": "Space Mono, Fira Code, SF Mono, Consolas, Liberation Mono, Menlo, monospace"
} as const;

export const fontSize = {
  "caption": 12,
  "meta": 14,
  "body": 16,
  "titleS": 18,
  "title": 24,
  "headline": 32,
  "display": 48
} as const;

export const lineHeight = {
  "caption": 16,
  "meta": 20,
  "body": 24,
  "titleS": 24,
  "title": 28,
  "headline": 36,
  "display": 52
} as const;

export const fontWeight = {
  "regular": 400,
  "medium": 500,
  "semibold": 600
} as const;

export const borderWidth = {
  "hairline": 1,
  "control": 2
} as const;

export const duration = {
  "fast": 120,
  "base": 220,
  "slow": 480
} as const;

export const easing = {
  "linear": [
    0,
    0,
    1,
    1
  ],
  "easeOut": [
    0.16,
    1,
    0.3,
    1
  ]
} as const;

export const shadow = {
  "light": {
    "1": {
      "boxShadow": "0px 1px 2px 0px rgba(42, 22, 15, 0.08)",
      "shadowColor": "#2a160f",
      "shadowOffset": {
        "width": 0,
        "height": 1
      },
      "shadowRadius": 1,
      "shadowOpacity": 0.08,
      "elevation": 1
    },
    "2": {
      "boxShadow": "0px 10px 20px -10px rgba(42, 22, 15, 0.35)",
      "shadowColor": "#2a160f",
      "shadowOffset": {
        "width": 0,
        "height": 6
      },
      "shadowRadius": 10,
      "shadowOpacity": 0.3,
      "elevation": 4
    }
  },
  "dark": {
    "1": {
      "boxShadow": "0px 1px 2px 0px rgba(0, 0, 0, 0.5)",
      "shadowColor": "#000000",
      "shadowOffset": {
        "width": 0,
        "height": 1
      },
      "shadowRadius": 1,
      "shadowOpacity": 0.5,
      "elevation": 1
    },
    "2": {
      "boxShadow": "0px 10px 20px -10px rgba(0, 0, 0, 0.7)",
      "shadowColor": "#000000",
      "shadowOffset": {
        "width": 0,
        "height": 6
      },
      "shadowRadius": 10,
      "shadowOpacity": 0.6,
      "elevation": 4
    }
  }
} as const;
